import './Key.scss';

interface KeyProps {
  focalAdvertiser: string;
  nonFocalAdvertisers: string[];
  type: string;
}

export const Key = ({ focalAdvertiser, nonFocalAdvertisers, type }: KeyProps) => {
  const resolvedFocalAdvertiser = focalAdvertiser === 'Joann' ? 'JOANN' : focalAdvertiser;
  return (
    <div className='key-container'>
      <div className='focal-advertiser'>
        {nonFocalAdvertisers.length > 0 ? resolvedFocalAdvertiser : type}
        <div className='line' />
      </div>
      {nonFocalAdvertisers.length > 0 && (
        <div className='competitor-section'>
          <div className='competitor-label'>
            {nonFocalAdvertisers.length <= 1 ? 'Competitor' : 'Competitors'}
            <div className='line' />
          </div>
          <div className='competitors'>{nonFocalAdvertisers.join(', ')}</div>
        </div>
      )}
    </div>
  );
};
